
<div class="row">
    <div class="col mt-4">
        <ejs-grid #returnOrderItemsGrid
            id="return-order-items-grid"
            [dataSource]="items"
            [height]="gridHeight"
            [allowPaging]="false"
            [allowFiltering]="true"
            [allowSorting]="true"
            [allowResizing]="true"
            [allowReordering]="true"
            [showColumnChooser]="true"
            [enablePersistence]="false"
            [allowExcelExport]="true"
            [query]="itemsQuery"
            [editSettings]="{ allowEditing: status !== 'Order Sent' && canEdit,  allowAdding: canEdit, allowDeleting: canEdit , newRowPosition: 'Top' }"
            [filterSettings]="{ type: 'Menu' }"
            (dataBound)="dataBound($event)"
            (rowDataBound)="rowDataBound($event)"
            (toolbarClick)="toolbarClick($event, returnOrderItemsGrid)"
            (created)="onGridCreated()"
            (actionBegin)="actionBegin($event)"
            (actionComplete)="actionComplete($event,returnOrderItemsGrid)"
            (commandClick)="commandColumnClick($event)"
            (load)="load($event)"
            >
            <e-columns>
                <e-column
                    *ngFor="let column of columns;"
                    [field]="column.field"
                    [headerText]="column.headerText"
                    [clipMode]="'EllipsisWithTooltip'"
                    [type]="column.type"
                    [edit]="column.edit"
                    [width]="column.width"
                    [filter]="column.filter ? column.filter : { type: 'Menu' }"
                    [format]="column.format ? column.format : null"
                    [textAlign]="column.textAlign"
                    [visible]="column.visible"
                    [foreignKeyValue]="column.foreignKeyValue"
                    [foreignKeyField]="column.foreignKeyField"
                    [dataSource]="column.dataSource"
                    [isPrimaryKey]="column.isPrimaryKey || false"
                    [validationRules]="column?.validationRules || null"
                    [commands]="column?.commands ? column.commands : null"
                    [showInColumnChooser]="column.showInColumnChooser ?? true"
                    [allowEditing]="column.allowEditing"
                    [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                    <ng-template *ngIf="column.headerText === 'Item'" #headerTemplate let-data>
                        <div>
                            Item <span class="required-asterik">*</span>
                        </div>
                    </ng-template>
                    <ng-template *ngIf="column.headerText === 'Quantity'" #headerTemplate let-data>
                        <div>
                            Quantity <span class="required-asterik">*</span>
                        </div>
                    </ng-template>
                    <ng-template *ngIf="column.headerText === 'Reason'" #headerTemplate let-data>
                        <div>
                            Reason <span class="required-asterik">*</span>
                        </div>
                    </ng-template>
                    <ng-template *ngIf="column.field === 'itemCode'" #template let-data>
                    <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemCode}}</a>
                    </ng-template>
                    <ng-template *ngIf="column.field === 'itemDescription'" #template let-data>
                    <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemDescription}}</a>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>

<ng-template #returnOrderItemsColumnChooser>
    <app-column-chooser
        [grid]="returnOrderItemsGrid"
        (onClose)="showColumnChooser = false"
    ></app-column-chooser>
</ng-template>

<app-items-advanced-search
    *ngIf="showItemAdvancedSearchPopup"
    [category]="category"
    [warehouse]="warehouse"
    [technicianId]="technicianId"
    [module]="'ReturnOrder'"
    (onClose)="onItemAdvancedSearchPopupClose($event)"
></app-items-advanced-search>
